// Etiquetas y reglas puras de la vista de Catálogo de productos.
import type { ProductCategoryWire } from '@/api/services/retail-catalog/backoffice/contract';
import type {
    ProductComponent,
    TrackingMode,
} from '@/api/services/retail-catalog/catalog.contract';

export const CATEGORY_LABEL: Record<ProductCategoryWire, string> = {
    PHONE: 'Teléfono',
    SIM: 'Chip',
    MODEM: 'Módem',
    ACCESSORY: 'Accesorio',
    BUNDLE: 'Kit',
};

export const TRACKING_LABEL: Record<TrackingMode, string> = {
    IMEI: 'IMEI',
    SERIAL: 'Serie',
    QUANTITY: 'Cantidad',
};

/** Un kit o un producto por cantidad no tiene piezas; sin campos nuevos se asume por pieza. */
export function tracksPieces(product: {
    category?: ProductCategoryWire;
    trackingMode?: TrackingMode;
}): boolean {
    return product.category !== 'BUNDLE' && product.trackingMode !== 'QUANTITY';
}

export function formatComponents(components: ProductComponent[] | null | undefined): string {
    return (components ?? []).map((c) => `${String(c.qty)} × ${c.sku}`).join(' · ');
}
